import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import messageIcon from '../../images/message-icon.svg';
import { buildUrlAndOpenSameWindow, navigateToUrl } from '../../../../../utilities/StringHelpers/StringHelpers';

const MessagePage = (props) => {

    let image= messageIcon;
    let title = '';
    let subTitle = '';
    let btnText = '';
    let btnUrl = '';

    switch (props.type) {
        case 'ROUTER_NOT_SUPPORTED':
            title = 'נתב לא נתמך';
            subTitle = 'המשך לפי ההנחיות הידניות';
            btnText = 'המשך להנחיות הידניות';
            btnUrl = props.genericWizardManualBlock;
            break;
        default:
    };

    function handleOnClickBtn() {
        navigateToUrl(btnUrl);
    };

    return (
        <div className='wizard-message-page'>
            <div className='content'>
                <div className='message-icon'><Image src={image} alt='message-icon' /></div>
                <h1 className='title'>{title}</h1>
                <p className='sub-title'>{subTitle}</p>
            </div>
          <div className='button-wrapper'>
              <BtnSubmit
                  text={btnText}
                  onclick={handleOnClickBtn}
                  formid='message-page'
              />
          </div>
        </div>
    );
};

const mapStateToProps = (state) => {
  return {
    type: state.speedTestAndDisconnectionsWizardBlock.messageType,
    genericWizardManualBlock: state.speedTestAndDisconnectionsWizardBlock.epiBlockData.genericWizardManualBlock,

  };
};

const mapDispatchToProps = {  };

export default connect(mapStateToProps, mapDispatchToProps)(MessagePage);
